export default __webpack_public_path__ + "static/media/ic_subtitle.851d971d.svg";